<div class="outer-container">
  <div class="division">
    <div class="column1">
      <div class="card-container">
        <!-- <div class="impact-card">
          <div class="header">TARGET IMPACT</div>
          <div class="content">
            ${{ algorithm.target_impact | numberSuffix : 1 }}
          </div>
        </div>
        <div class="impact-card">
          <div class="header">TARGET IMPACT %</div>
          <div class="content" style="color: #0c0c0c">
            {{ algorithm.target_impact_per | percent }}
          </div>
        </div> -->
        <div class="impact-card">
          <div class="header">ACTUAL IMPACT</div>
          <div class="content">
            ${{ algorithm.actual_impact | numberSuffix : 1 }}
          </div>
        </div>
        <div class="impact-card">
          <div class="header">ACTUAL IMPACT %</div>
          <div class="content" style="color: #0c0c0c">
            {{ algorithm.actual_impact_per | percent }}
          </div>
        </div>
      </div>

      <div class="note-container">
        <div class="card">
          <div class="content">
            <span class="text">
              Sales growth was {{ algorithm.x | percent }} with a margin growth
              of {{ algorithm.y | numberSuffix : 1 }} p.p</span>
            <p>SALES IMPACT</p>
          </div>
        </div>
        <div class="card">
          <div class="content">
            <span class="text">
              Price Impact is ${{ algorithm.a | numberSuffix : 1 }} with an
              impact percentage of {{ algorithm.b | percent }}</span>
            <p>PRICE IMPACT</p>
          </div>
        </div>
        <div class="card">
          <div class="content">
            <span class="text">
              Volume Impact is ${{ algorithm.h | numberSuffix : 1 }} with an
              impact percentage of {{ algorithm.j | percent }}</span>
            <p>VOLUME IMPACT</p>
          </div>
        </div>
      </div>

      <div class="card-container margin-top">
        <button class="{{ selectedDi === 'All' ? 'btnClr' : 'btn' }}" (click)="byRegion()">
          Sales by Region
        </button>
        <button class="{{ selectedBtn === 'sales' ? 'btnClr' : 'btn' }}" type="submit" value="sales"
          (click)="salesButton()">
          Sales Realization
        </button>
        <button class="{{ selectedBtn === 'margin' ? 'btnClr' : 'btn' }}" (click)="marginButton()">
          Margin Realization
        </button>
        <button class="{{ selectedBtn === 'daily' ? 'btnClr' : 'btn' }}" value="daily" (click)="dailyButton()">
          Daily Sales
        </button>
      </div>
      <div class="chart-box margin-top">
        <div>
          <app-sales-by-region-chart *ngIf="
              selectedDi == 'All' && salesByRegion.length !== 0 && top5Loaded
            " [salesByRegion]="salesByRegion" (onLegendClick)="legendClick($event)"
            legend="region"></app-sales-by-region-chart>

          <app-top5-chart *ngIf="selectedDi !== 'All' && top5.length !== 0 && top5Loaded" [top5]="top5"
            [button]="selectedDi"></app-top5-chart>
        </div>
        <div>
          <app-ces-after-market-sales-realization-chart source="nrp" *ngIf="
              selectedBtn == 'sales' && salesReal.length !== 0 && dataLoaded
            " [salesReal]="salesReal" (chartClick)="onChartClick($event)"></app-ces-after-market-sales-realization-chart>
          <app-margin-realization-chart *ngIf="
              selectedBtn == 'margin' && marginReal.length !== 0 && dataLoaded
            " [marginReal]="marginReal"></app-margin-realization-chart>

          <!-- <app-daily-sales-line-chart
            *ngIf="
              selectedBtn == 'daily' && dailySales.length !== 0 && dataLoaded
            "
            [dailySales]="dailySales"
            [dailyrdio]="dailyrdio"
            (selectedDiamension)="selectedDiamension($event)"
          ></app-daily-sales-line-chart> -->

          <app-ebu-daily-sales-line-chart *ngIf="
              selectedBtn == 'daily' && dailySales.length !== 0 && dataLoaded
            " [dailySales]="dailySales" [dailyrdio]="dailyrdio"
            (selectedDiamension)="selectedDiamension($event)"></app-ebu-daily-sales-line-chart>
        </div>
      </div>
    </div>
    <div class="column2">
      <div class="high-value-title">
        <span class="subhead">{{ title }}</span>
        <span (click)="resetFilter()" class="reset"><img src="../../../../../assets/images/clear.png" />&nbsp;
          RESET</span>
      </div>

      <div class="filter">
        <span class="filter">
          <mat-icon style="color: black">filter_alt_outline </mat-icon>
          Filter</span>
        <span>|</span>
        <button fxFlexAlign="top right" mat-icon-button [matMenuTriggerFor]="filterMenu">
          Top 5
        </button>

        <mat-menu #filterMenu="matMenu">
          <div class="pad-menu" fxLayout="column">
            <mat-radio-group fxLayout="column" class="bottom-separator" [(ngModel)]="radio">
              <mat-radio-button class="rdbtn" value="engine_model"
                (change)="searchDimension($event.value)">Engine</mat-radio-button>
              <mat-radio-button class="rdbtn" value="certification"
                (change)="searchDimension($event.value)">Certification</mat-radio-button>
              <mat-radio-button class="rdbtn" value="ecc"
                (change)="searchDimension($event.value)">ECC</mat-radio-button>
              <mat-radio-button class="rdbtn" value="parts"
                (change)="searchDimension($event.value)">Parts</mat-radio-button>
            </mat-radio-group>
          </div>
        </mat-menu>
      </div>

      <app-ces-after-market-selection *ngIf="formDetails" [formDetails]="formDetails"
        [selectedValues]="selectedValues" (onSelectFilter)="searchSalesData($event)"
        [reset]="reset"></app-ces-after-market-selection>
    </div>
  </div>
</div>